import { Col, Row } from 'antd';
import type { MappedCustomDataField, VatSelectValue } from 'common/models';
import { LabeledText } from 'components';
import { valueCurrencyShortcut } from 'helpers/priceHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface Props {
  customData: MappedCustomDataField;
  vatBase: number;
  currencyId: string;
}

const VatSelectInfo: React.FC<Props> = (props): React.ReactElement => {
  const { customData, vatBase, currencyId } = props;

  const { t } = useCustomTranslation();

  const vatSelectValue = customData.value as VatSelectValue | undefined;

  const rate = vatSelectValue ? vatSelectValue.rate : 0;

  const rateValue = vatBase * (rate / 100);

  const totalCost = vatBase + rateValue;

  return (
    <Row gutter={16} className="VatSelectInfo">
      <Col span={8}>
        <LabeledText label={customData.label} value={vatSelectValue?.stringValue || ''} />
      </Col>
      <Col span={4}>
        <LabeledText
          label={t('orders.customForms.vatSelect.base')}
          value={valueCurrencyShortcut(vatBase, currencyId, t)}
        />
      </Col>
      <Col span={4}>
        <LabeledText label={t('orders.customForms.vatSelect.rate')} value={`${rate} %`} />
      </Col>
      <Col span={4}>
        <LabeledText
          label={t('orders.customForms.vatSelect.rateValue')}
          value={valueCurrencyShortcut(rateValue, currencyId, t)}
        />
      </Col>
      <Col span={4} className="VatSelectInfo_totalCost">
        <LabeledText
          label={t('orders.customForms.vatSelect.totalPrice')}
          value={valueCurrencyShortcut(totalCost, currencyId, t)}
        />
      </Col>
    </Row>
  );
};

export default VatSelectInfo;
